// src/AirplaneTakeOff.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var AirplaneTakeOff_default = createIcon({
  displayName: "AirplaneTakeOff",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { opacity: "0", width: "24", height: "24", fill: "white", fillOpacity: "0" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M6.59151 5.00059C6.4822 5.00388 6.37134 5.02032 6.2639 5.05208C5.48523 5.28334 5.12814 6.16396 5.53217 6.85416L9.63799 13.8636L3.40154 15.4738L1.58417 13.9783C1.33563 13.7734 0.998427 13.7058 0.687446 13.798C0.0899714 13.973 -0.183208 14.6516 0.13267 15.1789L1.71091 17.8141C2.26676 18.7416 3.38381 19.1943 4.44653 18.9211L22.4744 14.2731C22.4768 14.2724 22.4791 14.2716 22.4815 14.2708C23.3593 14.1198 23.9995 13.3737 24 12.5015C24 11.5088 23.1778 10.7041 22.1635 10.7041C22.0036 10.7041 21.8445 10.7246 21.69 10.7649V10.7626L15.2862 12.4125L7.49063 5.33058C7.24362 5.1059 6.91944 4.9907 6.59151 5.00059Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      }
    )
  ] })
});

export {
  AirplaneTakeOff_default
};
